import { render, staticRenderFns } from "./ApiManagement.vue?vue&type=template&id=7fd52850&scoped=true&"
import script from "./ApiManagement.vue?vue&type=script&lang=js&"
export * from "./ApiManagement.vue?vue&type=script&lang=js&"
import style0 from "./ApiManagement.vue?vue&type=style&index=0&id=7fd52850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd52850",
  null
  
)

export default component.exports